import { COLORS } from 'layout/theme/colors'

export const treeViewStyles = {
    root: {
        height: '100%',
        position: 'relative',
        overflow: 'scroll',
        marginBottom: '50px'
    },
    nodeActionButton: {
        height: '100%',
        color: `${COLORS.theme.secondary.main}`,
        '&:hover': {
            color: `${COLORS.theme.secondary.dark}`,
            backgroundColor: 'transparent'
        }
    }
}
